/* Decottaa teması – ürün sayfası (varyant seçimi, sepete ekleme, galeri). */
(() => {
  const theme = window.theme || {};
  const strings = theme.strings || {};
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  const formatMoney = (cents, format = theme.moneyFormat || '{{amount}}') => {
    const value = Number(cents) || 0;
    const fixed = (precision, thousands, decimal) => {
      const [whole, fraction] = (value / 100).toFixed(precision).split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fraction ? grouped + decimal + fraction : grouped;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
      switch (key) {
        case 'amount_with_comma_separator':
          return fixed(2, '.', ',');
        case 'amount_no_decimals':
          return fixed(0, ',', '.');
        case 'amount_no_decimals_with_comma_separator':
          return fixed(0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return fixed(2, "'", '.');
        case 'amount_with_space_separator':
          return fixed(2, ' ', ',');
        default:
          return fixed(2, ',', '.');
      }
    });
  };

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.productUrl = this.dataset.productUrl;
      this.addEventListener('submit', (event) => this.onSubmit(event));
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('change', (event) => this.onChange(event));
    }

    get info() {
      return $('[data-product-info]', this);
    }

    get form() {
      return document.getElementById(this.dataset.formId);
    }

    get quantityInput() {
      return $('[data-qty-input]', this);
    }

    onClick(event) {
      const step = event.target.closest('[data-qty]');
      if (!step) return;
      const input = this.quantityInput;
      if (!input) return;
      const increment = Number(input.step) || 1;
      const min = Number(input.min) || 1;
      const max = input.max ? Number(input.max) : Infinity;
      const next = Number(input.value) + (step.dataset.qty === 'plus' ? increment : -increment);
      input.value = Math.min(max, Math.max(min, next));
      this.updateSubtotal();
    }

    onChange(event) {
      if (event.target.matches('[data-qty-input]')) {
        const input = event.target;
        const min = Number(input.min) || 1;
        const max = input.max ? Number(input.max) : Infinity;
        input.value = Math.min(max, Math.max(min, Number(input.value) || min));
        this.updateSubtotal();
        return;
      }
      if (event.target.closest('[data-variant-picker]')) this.onVariantChange(event.target);
    }

    updateSubtotal() {
      const input = this.quantityInput;
      const info = this.info;
      if (!input || !info) return;
      const quantity = Number(input.value) || 1;
      const note = $('[data-qty-note]', info);
      const total = $('[data-total]', info);
      if (note) note.textContent = String(quantity);
      if (total) total.textContent = formatMoney(Number(info.dataset.variantPrice) * quantity);
    }

    async onVariantChange(changedInput) {
      const picker = changedInput.closest('[data-variant-picker]');
      const optionValueIds = $$('input:checked', picker).map((input) => input.dataset.optionValueId);
      const focusId = changedInput.id;
      const quantity = this.quantityInput?.value;
      const url = `${this.productUrl}?section_id=${encodeURIComponent(this.sectionId)}&option_values=${optionValueIds.join(',')}`;
      this.info.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url);
        const doc = parseHTML(await response.text());
        const freshInfo = $('[data-product-info]', doc);
        if (!freshInfo) throw new Error('missing');
        this.info.replaceWith(freshInfo);
        if (quantity && this.quantityInput) this.quantityInput.value = quantity;
        this.updateSubtotal();
        document.getElementById(focusId)?.focus();

        const variantId = freshInfo.dataset.variantId;
        if (variantId) {
          const params = new URLSearchParams(window.location.search);
          params.set('variant', variantId);
          window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
        }
        const mediaId = freshInfo.dataset.featuredMedia;
        if (mediaId) $('media-gallery', this)?.show(mediaId);

        const live = $('[data-variant-live]', freshInfo);
        const price = $('[data-price-block] strong', freshInfo);
        if (live && price) live.textContent = price.textContent.trim();
      } catch (error) {
        this.info.removeAttribute('aria-busy');
      }
    }

    async onSubmit(event) {
      const form = this.form;
      if (!form || event.target !== form || typeof theme.addToCart !== 'function') return;
      event.preventDefault();
      const button = $('[data-add-to-cart]', this);
      const errorBox = $('[data-form-error]', this);
      if (button?.disabled) return;
      button?.setAttribute('aria-busy', 'true');
      if (button) button.disabled = true;
      if (errorBox) errorBox.hidden = true;
      try {
        await theme.addToCart(new FormData(form), button);
      } catch (error) {
        if (errorBox) {
          errorBox.textContent = error.message || strings.cartError;
          errorBox.hidden = false;
        }
      } finally {
        button?.removeAttribute('aria-busy');
        if (button) button.disabled = false;
      }
    }
  }
  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);

  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.lightbox = $('[data-lightbox]', this);
      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-gallery-step]');
        if (step) return this.step(Number(step.dataset.galleryStep));
        const thumb = event.target.closest('[data-thumb]');
        if (thumb) {
          this.show(thumb.dataset.thumb);
          return;
        }
        if (event.target.closest('[data-lightbox-open]') || event.target.closest('.main-photo__item[data-media-type="image"] img')) {
          this.openLightbox();
        }
      });
      if (this.lightbox) {
        this.lightbox.addEventListener('click', (event) => {
          if (event.target === this.lightbox || event.target.closest('[data-lightbox-close]')) this.lightbox.close();
        });
        this.lightbox.addEventListener('close', () => this.lastFocus?.focus());
      }
      // Mobilde görsel üzerinde parmakla kaydırma
      const photo = $('.main-photo', this);
      photo?.addEventListener('touchstart', (event) => (this.touchX = event.touches[0].clientX), { passive: true });
      photo?.addEventListener('touchend', (event) => {
        const distance = event.changedTouches[0].clientX - this.touchX;
        if (Math.abs(distance) > 45) this.step(distance < 0 ? 1 : -1);
      }, { passive: true });
    }

    step(direction) {
      const items = $$('.main-photo__item[data-media-id]', this);
      const index = items.findIndex((item) => !item.hidden);
      const next = items[(index + direction + items.length) % items.length];
      if (next) this.show(next.dataset.mediaId);
    }

    activeItem() {
      return $$('.main-photo__item', this).find((item) => !item.hidden);
    }

    show(mediaId) {
      const items = $$('.main-photo__item[data-media-id]', this);
      if (!items.some((item) => item.dataset.mediaId === String(mediaId))) return;
      items.forEach((item) => {
        const active = item.dataset.mediaId === String(mediaId);
        if (!active) $$('video', item).forEach((video) => video.pause());
        item.hidden = !active;
      });
      $$('[data-thumb]', this).forEach((thumb) => {
        const active = thumb.dataset.thumb === String(mediaId);
        thumb.classList.toggle('active', active);
        if (active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }

    openLightbox() {
      const item = this.activeItem();
      if (!this.lightbox || !item || item.dataset.mediaType !== 'image') return;
      const stage = $('[data-lightbox-stage]', this.lightbox);
      const image = document.createElement('img');
      image.src = item.dataset.zoomSrc;
      image.alt = item.dataset.zoomAlt || '';
      image.width = 1600;
      image.height = 1600;
      stage.replaceChildren(image);
      this.lastFocus = document.activeElement;
      this.lightbox.showModal();
    }
  }
  if (!customElements.get('media-gallery')) customElements.define('media-gallery', MediaGallery);

})();
